import type { ComponentProps } from 'react';

import { TextArea } from './ReadArea.styles';

function ReadArea(props: ComponentProps<typeof TextArea>) {
    return <TextArea readOnly rows={4} wide {...props} />;
}

export default ReadArea;
